import {Injectable, signal} from '@angular/core';
import {Subject} from 'rxjs';
import {SettingsService} from '../api/services/setting.service';
import {OverlayElement} from '../api/interfaces/overlay-element.interface';

@Injectable({providedIn: 'root'})
export class SidebarService {
  private editModeSignal = signal(this.loadFromLocalStorage());
  private selectedOverlayElementSignal = signal<OverlayElement | null>(null);
  public overlayElementChanged$ = new Subject<OverlayElement | null>();

  changeSelectedOverlayElement(element: OverlayElement | null) {
    this.selectedOverlayElementSignal.set(element);
    this.overlayElementChanged$.next(element);
  }

  getSelectedOverlayElement(): OverlayElement | null {
    return this.selectedOverlayElementSignal();
  }

  constructor(private settingsService: SettingsService) {
  }

  getEditModeSignal() {
    return this.editModeSignal();
  }

  toggleEditMode() {
    this.editModeSignal.set(!this.editModeSignal());
  }

  enableEditMode() {
    this.editModeSignal.set(true);
    this.setLocalStorageSettings(true);
  }

  disableEditMode() {
    this.editModeSignal.set(false);
    this.setLocalStorageSettings(false);
  }

  private loadFromLocalStorage(): boolean {
    return this.settingsService.getLocalStorageSettings().isEditMode || false;
  }

  private setLocalStorageSettings(isEditMode: boolean) {
    const settings = this.settingsService.getLocalStorageSettings();
    settings.isEditMode = isEditMode;
    this.settingsService.setLocalStorageSettings(settings);
  }
}
